export default {
  quantities: ['4', '10', '20', '50'],
  double_sided_smt: '0',
  lead_free: '0',
  bom_line_items: '',
  class_3_inspection: '0',
  smt: '',
  thru_hole: '',
  bga: '',
  qfn: '',
  fine_pitch: '0',
  part_number: '',
  revision: '',
};
